var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 60,
    viewBox: "0 0 31 60",
    strokeLinejoin: "round"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2 43.2c-1-0.9-2.6-0.9-3.6 0l-8.5 8.2 0-49c0-1.4-1.2-2.5-2.6-2.5 -1.4 0-2.6 1.1-2.6 2.5l0 49 -8.5-8.2c-1-1-2.7-0.9-3.7 0.1 -1 1-1 2.5 0 3.5l12.9 12.5c1 1 2.6 1 3.7 0 0 0 0 0 0 0l12.9-12.5c1-1 1-2.6-0.1-3.5Z"
  })));
};
export default SvgArrowDown;